<span class="label">{{ label }}</span>
@if (value?.length) {
  <ol class="list">
    @for (item of value; track $index) {
      <li class="list-item">{{ item }}</li>
    }
  </ol>
} @else {
  <span class="value empty"></span>
}
